module.exports = __webpack_public_path__ + "img/bsc.42c0d0f9.png";